require('./dist/angular-filter.js');
module.exports = 'angular.filter';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-filter/index.js
 ** module id = 10
 ** module chunks = 1
 **/